import React from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import Fontstyling from "../../../../components/common/comman";
import { useState } from "react";
import { useRef } from "react";
import { useEffect } from "react";
import * as Yup from "yup";
import { Formik } from "formik";
import { toast, ToastContainer } from "react-toastify";
import {
  AddDrf,
  DeleteDrf,
  GetDrfDetails,
  UpdateDrf,
} from "../../../../api/User/ACG/DRFApi";
import CustomButton from "../../../../components/common/CustomButton";
import DeleteModal from "../../../../components/common/Modal/DeleteModal";
import CustomMaterialTable from "../../../../components/common/CustomMaterialTable";
import toastFile from "../../../../Service/ToastFile";
import CustomInputField from "../../../../components/common/CustomInputField";

const schema = Yup.object().shape({
  MEDC: Yup.string().required("Please enter MEDC"),
  maleDRF: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter male DRF"),
  femaleDRF: Yup.number()
    .typeError("Please enter a valid number")
    .required("Please enter female DRF"),
});

const DRF = () => {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [isGetData, setIsGetData] = useState(false);
  const [witchAction, setWitchAction] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const buttonRef = useRef(null);
  const column = [
    { title: "MEDC", field: "medc" },
    { title: "Male DRF", field: "maleDRF" },
    { title: "Female DRF", field: "femaleDRF" },
  ];

  useEffect(() => {
    if (showModal === false) {
      setSelectedRowData(null);
    }
    if (isGetData) {
      getMEDCData();
    }
    setIsGetData(false);
  }, [showModal]);

  useEffect(() => {
    getMEDCData();
  }, []);

  const getMEDCData = () => {
    setIsLoading(true);
    GetDrfDetails()
      .then((res) => {
        if(res.status === 200 || res.status === 204){
        setData(res.data);
        }
      })
      .catch((err) => console.log({ err }))
      .finally((res) => setIsLoading(false));
  };

  const handleActions = (values) => {
    buttonRef.current.disabled = true;
    if (witchAction === "add") {
      let payload = {
        id: 0,
        medc: values.MEDC,
        maleDRF: +values.maleDRF,
        femaleDRF: +values.femaleDRF,
        natDRF: 0,
      };
      setData([...data, payload]);
      AddDrf(payload).then((res) => {
        if(res.status === 200 || res.status === 204){
        setIsGetData(true);
        toastFile("new");
        setShowModal(false);
        }else if (res?.response?.status === 400) {
          toastFile(res?.response?.data,'error');
          setShowModal(false);
        }
      });
    } else if (witchAction === "update") {
      let payload = {
        id: selectedRowData.id,
        medc: values.MEDC,
        maleDRF: +values.maleDRF,
        femaleDRF: +values.femaleDRF,
        natDRF: selectedRowData.natDRF,
      };
      const updatedData = data.map((item, index) => {
        if (index === selectedRowData?.tableData.id) {
          return { ...item, ...payload };
        }
        return item;
      });
      setData(updatedData);
      UpdateDrf(payload, selectedRowData.id).then((res) => {
        if(res.status === 200 || res.status === 204){
        setIsGetData(true);
        toastFile("update");
        setShowModal(false);
        }else if (res?.response?.status === 400) {
          toastFile(res?.response?.data,'error');
          setShowModal(false);
        }
      });
    }
  };

  return (
    <div>
      <Modal
        show={showModal}
        aria-labelledby="contained-modal-title-vcenter"
        centered={witchAction !== "delete"}
      >
        <Modal.Header closeButton onHide={() => setShowModal(false)}>
          <Modal.Title
            id="contained-modal-title-vcenter"
            style={Fontstyling.modalHeading}
          >
            {witchAction === "add"
              ? "Add "
              : witchAction === "update"
              ? "Update "
              : "Delete "}
            DRF
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {witchAction === "delete" ? (
            <DeleteModal
              onClickYes={() => {
                DeleteDrf(selectedRowData?.id).then((res) => {
                  if(res.status === 200 || res.status === 204){
                  toastFile("delete");
                  setIsGetData(true);
                  setShowModal(false);
                  }
                });
              }}
              onClickNo={() => setShowModal(false)}
            />
          ) : (
            <Formik
              validationSchema={schema}
              onSubmit={handleActions}
              initialValues={{
                MEDC: selectedRowData ? selectedRowData.medc : "",
                maleDRF: selectedRowData ? selectedRowData.maleDRF : 0,
                femaleDRF: selectedRowData ? selectedRowData.femaleDRF : 0,
              }}
            >
              {({
                handleSubmit,
                handleChange,
                handleBlur,
                values,
                touched,
                isValid,
                errors,
              }) => (
                <Form onSubmit={handleSubmit}>
                  <Row className="mb-2 gap-3">
                    <CustomInputField
                      label="MEDC"
                      name="MEDC"
                      value={values}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      touched={touched}
                      errors={errors}
                      isRequired
                    />
                    <CustomInputField
                      label="Male DRF"
                      name="maleDRF"
                      maxLength={10}
                      value={values}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      touched={touched}
                      errors={errors}
                      isRequired
                    />
                    <CustomInputField
                      label="Female DRF"
                      name="femaleDRF"
                      maxLength={10}
                      value={values}
                      handleChange={handleChange}
                      handleBlur={handleBlur}
                      touched={touched}
                      errors={errors}
                      isRequired
                    />
                  </Row>
                  <div className="d-flex align-items-center justify-content-end gap-3 my-4">
                    <button
                      ref={buttonRef}
                      style={Fontstyling.savebutton}
                      type="submit"
                    >
                      save
                    </button>
                    <button
                      style={Fontstyling.cancelbutton}
                      type="reset"
                      onClick={() => setShowModal(false)}
                    >
                      Cancel
                    </button>
                  </div>
                  <span className="text-success" style={{fontSize:"12px"}}>
                    * No special characters are allowed
                  </span>
                </Form>
              )}
            </Formik>
          )}
        </Modal.Body>
      </Modal>
      <div className="text-end py-3 border-bottom">
        <CustomButton
          onClick={() => {
            setWitchAction("add");
            setShowModal(true);
          }}
        >
          Add DRF
        </CustomButton>
      </div>
      <CustomMaterialTable
        column={column}
        data={data}
        selectedRow={selectedRow}
        setSelectedRow={setSelectedRow}
        setWitchAction={setWitchAction}
        setSelectedRowData={setSelectedRowData}
        setShowModal={setShowModal}
        isLoading={isLoading}
      />
    </div>
  );
};

export default DRF;
